(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('AssessmentsController', AssessmentsController);

  /* ngInject */
  function AssessmentsController($stateParams, assessmentService, riskLevels, sessionService, vendorService) {
    const vm = this;

    vm.assessments = [];
    vm.currentPage = $stateParams.currentPage || 1;
    vm.filterResults = filterResults;
    vm.loading = false;
    vm.myAssessmentAssignments = [];
    vm.pageChange = pageChange;
    vm.riskLevels = riskLevels;
    vm.riskLevelIdFilter = null;
    vm.statusFilter = null;
    vm.totalCount = null;
    vm.vendors = [];
    vm.vendorIdFilter = null;

    activate();

    function activate() {
      getAssessments();
      getVendors();
      getMyAssessmentAssignments();
    }

    function filterResults() {
      vm.assessments = [];
      vm.currentPage = 1;
      getAssessments();
    }

    function getAssessments() {
      vm.loading = true;

      let queryParams = {
        'q[id_eq]': vm.vendorFilter,
        'q[risk_level_id_eq]': vm.riskLevelIdFilter,
        'q[status_eq]': vm.statusFilter,
        page: vm.currentPage
      };

      assessmentService(sessionService.getAuthToken()).query(queryParams, response => {
        vm.loading = false;
        vm.assessments = response.data;
        vm.totalCount = parseInt(response.headers['x-total']);
      }, _ => {
        vm.loading = false;
      });
    }

    function getMyAssessmentAssignments() {
      assessmentService(sessionService.getAuthToken()).my_assignments({}, response => {
        vm.myAssessmentAssignments = response;
      });
    }

    function getVendors() {
      vendorService(sessionService.getAuthToken()).query(response => vm.vendors = response.data);
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.assessments = [];
      vm.currentPage = newPageNumber;
      getAssessments();
    }
  }
})();
